import { warn } from "@swivl-mono/helpers";
import React from "react";
import Dropzone from "react-dropzone";
import Resizer from "react-image-file-resizer";

import { Spinner } from "../Spinner/Spinner";
import "./ImageUploader.scss";

export enum ImageUploaderType {
  AVATAR = "AVATAR",
  LOCATION = "LOCATION",
}

interface Props {
  isEditable?: boolean;
  type: ImageUploaderType;
  imageURL?: string;
  imageUploaded?: (url: string) => void;
  text?: React.ReactNode;
  onUploaderStatusChanging?: (isUploading: boolean) => void;
}

const resizeFile = (file: File, type: ImageUploaderType) => {
  let width = 300;
  let height = 300;
  if (type === ImageUploaderType.LOCATION) {
    width = 800;
    height = 800;
  }

  return new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width,
      height,
      "WEBP",
      80,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
    );
  });
};

export const ImageUploader = (props: Props) => {
  const { imageURL } = props;
  const [file, setFile] = React.useState<File>();
  const [uploading, setUploading] = React.useState(false);

  if (!props.isEditable) {
    return (
      <div className="ImageUploader">
        <img src={imageURL} alt="Avatar" />
      </div>
    );
  }

  return (
    <div className={`ImageUploader ${props.type}`}>
      <div className="ImageUploaderInner">
        {uploading ? (
          <Spinner />
        ) : (
          <Dropzone
            accept={{
              "image/png": [".png"],
              "image/jpeg": [".jpg", ".jpeg"],
            }}
            maxFiles={1}
            onDrop={async (acceptedFiles: File[]) => {
              setUploading(true);
              props.onUploaderStatusChanging && props.onUploaderStatusChanging(true);

              const file = acceptedFiles[0];
              const resizedFile = (await resizeFile(file, props.type)) as File;

              const { uploadUrl, fileUrl } = await fetch(`${(import.meta as any).env.VITE_SERVER_URL}/api/s3/org/1/get-signed-url/file.jpg`).then(
                (res) => res.json(),
              );
              setFile(file);
              const response = await fetch(uploadUrl, {
                method: "PUT",
                body: resizedFile,
              });

              props.imageUploaded && props.imageUploaded(fileUrl);
              props.onUploaderStatusChanging && props.onUploaderStatusChanging(false);
              setUploading(false);
            }}
            onError={(error) => warn(error)}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <div className="innerWrapper" {...getRootProps()}>
                <input {...getInputProps()} />
                {props.text || <p>Drag 'n' drop some files here, or click to select files</p>}
              </div>
            )}
          </Dropzone>
        )}
      </div>
      <img src={imageURL} alt="Avatar" />
    </div>
  );
};
